import { Box, Typography, Container, Divider, SvgIcon, Button } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { KeyboardBackspace } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import img54 from "../../assets/newimg/logo.png";
import img54 from "../../assets/ocesha_images/ocesha_logo.png";

import { object, string, TypeOf } from "zod";
import { useSubscribeNewsMutation } from "../../redux/api/authApi";
import { toast } from "react-toastify";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";



const newsSubscribeform = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  status: string(),
})

export type NewsSubscriptionForm = TypeOf<typeof newsSubscribeform>
const  TermsPage = () => {
const navigate = useNavigate();
const handleLearnMore = () => {
  navigate('/codegenie/smart_contracts');
}
const [subscribeVal, setSubscribeVal] = useState<NewsSubscriptionForm>({ email: '', status: '' })
const [newsSubsctiptionMutation, newsSubscriptionState] = useSubscribeNewsMutation();

const methods = useForm<NewsSubscriptionForm>({
  resolver: zodResolver(newsSubscribeform),
});

const {
  register,
  handleSubmit,
  formState: { errors },
} = methods;

const onSubmitHandler: SubmitHandler<NewsSubscriptionForm> = (values) => {
  newsSubsctiptionMutation(values);
};

const [currentDate, setCurrentDate] = useState(new Date());

useEffect(() => {
  const timerID = setInterval(() => setCurrentDate(new Date()), 1000);
  return () => clearInterval(timerID);
}, []);


const formattedDate = currentDate.toLocaleDateString('en-US', {
  month: 'long',
  day: 'numeric',
  year: 'numeric'
});



const handleSubscribeNews = () => {
  newsSubsctiptionMutation(subscribeVal)
    .unwrap()
    .then((response) => {
      console.log('news subscription=>', response);
        const status = response.status;
      
        console.log(status);
        if (status === 'success') {
          toast.success(response.message);
          setSubscribeVal({
            email: '',
            status: ''
          });
        }
    })
    .catch((error) => {
      toast.error(error?.data?.detail ?? 'Something went wrong!');
      console.error('Error sending query:', error);

    });
}
  return (
    <>
    
      <Container maxWidth="lg">
      <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}>
              {/* <img src="./img/logo.png" alt="" /> */}
              <img src={img54} alt="" style={{ height: '70px' }}/>
              {/* <img src={logo} alt="" /> */}
  
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="">
                <i className="bi bi-list text-white" />
              </span>
            </button>



            
            <div className="collapse navbar-collapse" id="navbarScroll">
              <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll gap-4">{/* ms-md-5 */}
                <li className="nav-item">
                  <a
                    className="nav-link nav_active"
                    style={{ color: "#4ba5eb", fontWeight: 800 }}
                    href="/"
                  >
                    Home
                  </a>
                </li>




                <li className="nav-item">
                  <a className="nav-link nav_simple" href="https://ocesha-inc.getrewardful.com/signup?_gl=1*1lh53li*_gcl_au*MTc0Njg4MTI3Ni4xNzQ2NzMwMTA0*_ga*MTY2NzI5OTM0OC4xNzQ2NzMwMTA0*_ga_YJYFH7ZS27*czE3NDY3MzAxMDMkbzEkZzEkdDE3NDY3MzEwNjckajM3JGwwJGgw">
                    Affiliate
                  </a>
                </li> 
              </ul>


              
              <div className="d-flex gap-4" role="search">
              <button className="button_leniar px-3" type="submit"  onClick={() => {
                navigate("/signup");
              }}>
                  Try Now
                </button>
                <button className="btn btn-outline-primary px-3"
                  onClick={() => {
                    navigate("/signin");
                  }}>Sign  in</button>
              </div>
            </div>
          </div>
        </nav>
          <Box py={5}>
            <Typography
              variant="h2"
              color="text.secondary"
              fontWeight={600}
              textAlign="justify"
              mb={10}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                OceSha.ai Terms of Service
              </div>
            </Typography>

            {/* Intro */}
            <Typography>
              Last Updated: May 20, 2026
              <br /><br />
              These Terms of Service (&ldquo;Terms&rdquo;) constitute a legally binding agreement between you (&ldquo;User,&rdquo; &ldquo;Creator,&rdquo; &ldquo;Customer,&rdquo; &ldquo;you,&rdquo; or &ldquo;your&rdquo;) and OceSha, Inc. (&ldquo;OceSha,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) governing your access to and use of the OceSha platform, websites, applications, AI systems, Digital Twin technologies, Authority Pages, publishing infrastructure, APIs, educational tools, and related services (collectively, the &ldquo;Services&rdquo;).
              <br /><br />
              By creating an account, accessing the Services, uploading content, activating a Digital Twin, using AI-generated functionality, or otherwise using the platform, you agree to be bound by these Terms and our Privacy Policy.
              <br /><br />
              If you do not agree to these Terms, do not use the Services.
            </Typography>

            {/* 1 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              1. Nature of the Platform
            </Typography>
            <Typography>
              OceSha is an AI-powered authority, publishing, educational, and Digital Twin infrastructure platform designed to help users:
              <Box component="ul">
                <Box component="li">Create and publish AI-assisted content</Box>
                <Box component="li">Build public Authority Pages</Box>
                <Box component="li">Generate blogs, courses, clips, and educational materials</Box>
                <Box component="li">Create AI-powered Digital Twins</Box>
                <Box component="li">Scale knowledge and expertise through AI systems</Box>
                <Box component="li">Generate audience engagement and lead generation opportunities</Box>
                <Box component="li">Manage educational and monetization experiences</Box>
                <Box component="li">Repurpose content across multiple channels and platforms</Box>
              </Box>
              OceSha provides technology infrastructure and AI-assisted tools only.<br /><br />
              OceSha does not provide:
              <Box component="ul">
                <Box component="li">Legal advice</Box>
                <Box component="li">Financial advice</Box>
                <Box component="li">Medical advice</Box>
                <Box component="li">Tax advice</Box>
                <Box component="li">Business guarantees</Box>
                <Box component="li">Revenue guarantees</Box>
                <Box component="li">Educational accreditation</Box>
                <Box component="li">Professional certifications</Box>
              </Box>
              You acknowledge and agree that:
              <Box component="ul">
                <Box component="li">AI-generated outputs are probabilistic</Box>
                <Box component="li">Outputs may be inaccurate, incomplete, misleading, offensive, or non-unique</Box>
                <Box component="li">Human review is required before publication or reliance</Box>
                <Box component="li">You are solely responsible for all published content and use of Outputs</Box>
              </Box>
            </Typography>

            {/* 2 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              2. AI Systems &amp; Digital Twin Technology
            </Typography>
            <Typography>
              OceSha uses artificial intelligence, machine learning, generative systems, voice technologies, retrieval systems, and Digital Twin frameworks to generate Outputs and AI-assisted experiences.
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                2.1 Digital Twin Framework
              </Typography>
              By activating or using a Digital Twin, you acknowledge and agree that:
              <Box component="ul">
                <Box component="li">You are voluntarily providing content, voice, likeness, communication patterns, expertise, and related data</Box>
                <Box component="li">You represent and warrant that you own or control all rights necessary to upload and use such materials</Box>
                <Box component="li">You grant OceSha a limited, non-exclusive, revocable license to process and transform your content solely to provide the Services</Box>
              </Box>
              Your Digital Twin may:
              <Box component="ul">
                <Box component="li">Generate AI-assisted content</Box>
                <Box component="li">Answer questions</Box>
                <Box component="li">Participate in AI-powered educational experiences</Box>
                <Box component="li">Communicate using AI-generated voice interactions</Box>
                <Box component="li">Power Authority Page interactions</Box>
                <Box component="li">Generate educational or audience engagement experiences</Box>
              </Box>
              You acknowledge that:
              <Box component="ul">
                <Box component="li">Digital Twin interactions are AI-generated and automated</Box>
                <Box component="li">Digital Twin responses are not live human communications</Box>
                <Box component="li">AI systems may occasionally generate inaccurate or misleading information</Box>
                <Box component="li">Users interacting with your Digital Twin may perceive it as conversational or personality-based AI</Box>
              </Box>
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                2.2 Voice Personalization &amp; AI Voice Systems
              </Typography>
              If you provide voice samples or participate in voice interactions:
              <Box component="ul">
                <Box component="li">You consent to OceSha using those recordings to personalize AI voice experiences associated with your account</Box>
                <Box component="li">You acknowledge that AI-generated voice outputs may sound similar to your speaking style, tone, or voice characteristics</Box>
                <Box component="li">You understand that such systems are synthetic AI-generated outputs and not actual recordings of live human speech</Box>
              </Box>
              You may not:
              <Box component="ul">
                <Box component="li">Upload third-party voice recordings without consent</Box>
                <Box component="li">Clone or imitate another person without authorization</Box>
                <Box component="li">Use AI voice systems for fraud, impersonation, harassment, or deception</Box>
                <Box component="li">Misrepresent AI-generated interactions as live human communication in misleading ways</Box>
              </Box>
              OceSha reserves the right to suspend or terminate voice functionality if misuse is suspected.
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                2.3 Public AI Interactions
              </Typography>
              You acknowledge that your Digital Twin, Authority Page, or AI-powered systems may interact publicly with users through:
              <Box component="ul">
                <Box component="li">Public Authority Pages</Box>
                <Box component="li">AI chat interfaces</Box>
                <Box component="li">Educational systems</Box>
                <Box component="li">AI-assisted audience experiences</Box>
                <Box component="li">Public-facing AI interactions</Box>
              </Box>
              You are solely responsible for:
              <Box component="ul">
                <Box component="li">Reviewing generated Outputs where appropriate</Box>
                <Box component="li">Ensuring compliance with applicable laws</Box>
                <Box component="li">Avoiding misleading claims or unlawful conduct</Box>
              </Box>
            </Typography>

            {/* 3 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              3. User Content &amp; Upload Rights
            </Typography>
            <Typography>
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                3.1 User Input
              </Typography>
              You retain ownership of content you upload (&ldquo;Input&rdquo;).<br /><br />
              You represent and warrant that:
              <Box component="ul">
                <Box component="li">You own or have sufficient rights to all uploaded materials</Box>
                <Box component="li">Your uploads do not violate intellectual property, privacy, confidentiality, or publicity rights</Box>
                <Box component="li">Your uploads comply with applicable laws and regulations</Box>
              </Box>
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                3.2 Prohibited Uploads
              </Typography>
              You may not upload:
              <Box component="ul">
                <Box component="li">Illegal content</Box>
                <Box component="li">Copyright-infringing content</Box>
                <Box component="li">Confidential information without authorization</Box>
                <Box component="li">Third-party proprietary data without permission</Box>
                <Box component="li">Harmful malware or malicious files</Box>
                <Box component="li">Fraudulent, deceptive, or defamatory materials</Box>
                <Box component="li">Sensitive regulated data without proper authorization</Box>
              </Box>
              OceSha reserves the right to remove or restrict content at its discretion.
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                3.3 AI Outputs
              </Typography>
              Subject to your compliance with these Terms:
              <Box component="ul">
                <Box component="li">You retain rights to your Inputs</Box>
                <Box component="li">OceSha assigns to you any rights it may have in generated Outputs</Box>
                <Box component="li">Output ownership does not include OceSha infrastructure, systems, models, or algorithms</Box>
              </Box>
              Due to the nature of generative systems:
              <Box component="ul">
                <Box component="li">Outputs may not be unique</Box>
                <Box component="li">Similar outputs may be generated for other users</Box>
                <Box component="li">OceSha does not guarantee exclusivity</Box>
              </Box>
            </Typography>

            {/* 4 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              4. Authority Pages &amp; Public Publishing
            </Typography>
            <Typography>
              OceSha may create public-facing Authority Pages and publish content associated with your account.
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                4.1 Public Visibility
              </Typography>
              You acknowledge and agree that:
              <Box component="ul">
                <Box component="li">Published content may become publicly accessible</Box>
                <Box component="li">Content may be indexed by search engines</Box>
                <Box component="li">Content may appear in AI search systems and AI-generated search responses</Box>
                <Box component="li">Public content may be cached, archived, or stored by third parties</Box>
                <Box component="li">Search engine indexing may persist after deletion or cancellation</Box>
              </Box>
              OceSha does not control:
              <Box component="ul">
                <Box component="li">Third-party search engine caching</Box>
                <Box component="li">AI search indexing</Box>
                <Box component="li">Web archives</Box>
                <Box component="li">Third-party republishment or scraping</Box>
              </Box>
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                4.2 Cancellation &amp; Public Content
              </Typography>
              If your subscription is canceled:
              <Box component="ul">
                <Box component="li">OceSha may retain, archive, redirect, limit, or remove public-facing content</Box>
                <Box component="li">Authority Pages may remain partially accessible for a period of time</Box>
                <Box component="li">Certain content may display limited previews or archived states</Box>
                <Box component="li">OceSha may redirect inactive Authority Pages to other platform destinations</Box>
              </Box>
              OceSha reserves the right to determine how canceled or inactive accounts are handled operationally.
            </Typography>

            {/* 5 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              5. AI Educational Systems
            </Typography>
            <Typography>
              OceSha may generate:
              <Box component="ul">
                <Box component="li">Courses</Box>
                <Box component="li">Educational content</Box>
                <Box component="li">AI-assisted instruction</Box>
                <Box component="li">Interactive learning systems</Box>
                <Box component="li">AI-powered educational experiences</Box>
              </Box>
              You acknowledge and agree:
              <Box component="ul">
                <Box component="li">AI-generated educational content may contain inaccuracies</Box>
                <Box component="li">OceSha does not guarantee educational outcomes</Box>
                <Box component="li">OceSha is not an accredited educational institution</Box>
                <Box component="li">AI-generated instruction does not replace professional expertise or certified education</Box>
                <Box component="li">You are solely responsible for reviewing educational Outputs before publication or distribution</Box>
              </Box>
              OceSha disclaims responsibility for:
              <Box component="ul">
                <Box component="li">Student disputes</Box>
                <Box component="li">Educational claims</Box>
                <Box component="li">Certification disputes</Box>
                <Box component="li">Business coaching outcomes</Box>
                <Box component="li">Professional licensing compliance</Box>
              </Box>
            </Typography>

            {/* 6 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              6. Lead Generation &amp; Audience Engagement
            </Typography>
            <Typography>
              OceSha may provide lead generation, audience engagement, messaging, or communication tools.<br /><br />
              You acknowledge and agree that:
              <Box component="ul">
                <Box component="li">You are solely responsible for compliance with communication and marketing laws</Box>
                <Box component="li">You are responsible for obtaining any required consents</Box>
                <Box component="li">OceSha does not guarantee audience growth, leads, engagement, or monetization outcomes</Box>
              </Box>
              You may not use the Services for:
              <Box component="ul">
                <Box component="li">Spam</Box>
                <Box component="li">Harassment</Box>
                <Box component="li">Fraudulent solicitations</Box>
                <Box component="li">Misleading marketing</Box>
                <Box component="li">Unlawful communications</Box>
              </Box>
            </Typography>

            {/* 7 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              7. Monetization &amp; Payment Processing
            </Typography>
            <Typography>
              If you monetize through the platform:
              <Box component="ul">
                <Box component="li">You are responsible for your products, content, and customer relationships</Box>
                <Box component="li">You are responsible for taxes, refunds, disputes, and legal compliance</Box>
                <Box component="li">Payment processors operate under their own terms</Box>
                <Box component="li">OceSha does not guarantee revenue or monetization outcomes</Box>
              </Box>
              <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                7.1 Platform Subscription Billing
              </Typography>
              OceSha subscriptions:
              <Box component="ul">
                <Box component="li">May include trial periods</Box>
                <Box component="li">Require valid payment methods</Box>
                <Box component="li">Automatically renew unless canceled</Box>
                <Box component="li">Are billed according to selected subscription plans</Box>
              </Box>
              Users may:
              <Box component="ul">
                <Box component="li">Cancel subscriptions</Box>
                <Box component="li">Update payment methods</Box>
                <Box component="li">Download billing history</Box>
                <Box component="li">Manage subscription status</Box>
              </Box>
              Fees are non-refundable except where required by law.
            </Typography>

            {/* 8 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              8. Acceptable Use
            </Typography>
            <Typography>
              You may not use the Services to:
              <Box component="ul">
                <Box component="li">Violate laws or regulations</Box>
                <Box component="li">Create deceptive AI impersonations</Box>
                <Box component="li">Generate harmful or unlawful content</Box>
                <Box component="li">Infringe intellectual property rights</Box>
                <Box component="li">Reverse engineer platform systems</Box>
                <Box component="li">Train competing AI systems using OceSha systems or Outputs</Box>
                <Box component="li">Misrepresent AI-generated content as human communication in deceptive ways</Box>
                <Box component="li">Attempt unauthorized access to platform infrastructure</Box>
              </Box>
              OceSha reserves the right to:
              <Box component="ul">
                <Box component="li">Remove content</Box>
                <Box component="li">Suspend accounts</Box>
                <Box component="li">Disable Digital Twins</Box>
                <Box component="li">Restrict platform access</Box>
                <Box component="li">Cooperate with legal authorities</Box>
              </Box>
            </Typography>

            {/* 9 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              9. Data Use, Privacy &amp; AI Training
            </Typography>
            <Typography>
              OceSha may use aggregated and anonymized usage data to:
              <Box component="ul">
                <Box component="li">Improve platform performance</Box>
                <Box component="li">Enhance AI systems</Box>
                <Box component="li">Optimize infrastructure</Box>
                <Box component="li">Improve user experiences</Box>
              </Box>
              Unless explicitly stated otherwise:
              <Box component="ul">
                <Box component="li">Private uploaded user content is not used to train public AI systems</Box>
                <Box component="li">OceSha does not sell private uploaded user content</Box>
              </Box>
              Users remain responsible for ensuring they have rights to upload all submitted materials.
            </Typography>

            {/* 10 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              10. Beta Services &amp; Experimental Features
            </Typography>
            <Typography>
              Certain Services may be labeled as Beta, Experimental, Preview, or Early access.<br /><br />
              You acknowledge that beta features may:
              <Box component="ul">
                <Box component="li">Contain bugs</Box>
                <Box component="li">Experience outages</Box>
                <Box component="li">Produce errors</Box>
                <Box component="li">Change substantially</Box>
                <Box component="li">Lose data</Box>
                <Box component="li">Be discontinued without notice</Box>
              </Box>
              Beta features are provided &ldquo;AS IS&rdquo; without warranties.
            </Typography>

            {/* 11 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              11. Security &amp; Infrastructure
            </Typography>
            <Typography>
              While OceSha uses commercially reasonable safeguards:
              <Box component="ul">
                <Box component="li">No system is completely secure</Box>
                <Box component="li">Internet-based transmissions involve inherent risks</Box>
                <Box component="li">Users are responsible for maintaining account security</Box>
              </Box>
              OceSha is not liable for unauthorized access outside its reasonable control.
            </Typography>

            {/* 12 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              12. AI Limitations &amp; Risk Disclosure
            </Typography>
            <Typography>
              You acknowledge and agree that:
              <Box component="ul">
                <Box component="li">AI systems may hallucinate or generate inaccurate information</Box>
                <Box component="li">AI-generated content may be offensive or inappropriate</Box>
                <Box component="li">AI outputs may not reflect factual reality</Box>
                <Box component="li">Human review is required before reliance or publication</Box>
              </Box>
              OceSha disclaims responsibility for:
              <Box component="ul">
                <Box component="li">Business losses</Box>
                <Box component="li">Search ranking performance</Box>
                <Box component="li">Discoverability outcomes</Box>
                <Box component="li">Audience engagement outcomes</Box>
                <Box component="li">Monetization outcomes</Box>
                <Box component="li">Educational outcomes</Box>
                <Box component="li">Reputational harm arising from AI-generated Outputs</Box>
              </Box>
            </Typography>

            {/* 13 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              13. DISCLAIMERS
            </Typography>
            <Typography>
              THE SERVICES ARE PROVIDED &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE.&rdquo;<br /><br />
              TO THE FULLEST EXTENT PERMITTED BY LAW, OCESHA DISCLAIMS:
              <Box component="ul">
                <Box component="li">WARRANTIES OF MERCHANTABILITY</Box>
                <Box component="li">FITNESS FOR A PARTICULAR PURPOSE</Box>
                <Box component="li">NON-INFRINGEMENT</Box>
                <Box component="li">PLATFORM UPTIME GUARANTEES</Box>
                <Box component="li">REVENUE GUARANTEES</Box>
                <Box component="li">SEARCH OR DISCOVERABILITY GUARANTEES</Box>
                <Box component="li">ACCURACY GUARANTEES</Box>
                <Box component="li">BUSINESS OUTCOME GUARANTEES</Box>
              </Box>
              OceSha does not guarantee that:
              <Box component="ul">
                <Box component="li">Outputs will be accurate</Box>
                <Box component="li">AI systems will behave as expected</Box>
                <Box component="li">Authority Pages will rank in search engines</Box>
                <Box component="li">Content will generate traffic, leads, or revenue</Box>
              </Box>
            </Typography>

            {/* 14 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              14. Limitation of Liability
            </Typography>
            <Typography>
              To the fullest extent permitted by law:<br /><br />
              OceSha shall not be liable for:
              <Box component="ul">
                <Box component="li">Indirect damages</Box>
                <Box component="li">Consequential damages</Box>
                <Box component="li">Incidental damages</Box>
                <Box component="li">Lost profits</Box>
                <Box component="li">Lost revenue</Box>
                <Box component="li">Loss of goodwill</Box>
                <Box component="li">Data loss</Box>
                <Box component="li">Reputational harm</Box>
                <Box component="li">Search ranking losses</Box>
                <Box component="li">AI-generated inaccuracies</Box>
                <Box component="li">Third-party misuse of public content</Box>
              </Box>
              Total aggregate liability shall not exceed the greater of fees paid during the previous 12 months, or $1,000 USD.
            </Typography>

            {/* 15 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              15. Indemnification
            </Typography>
            <Typography>
              You agree to indemnify and hold harmless OceSha and its officers, employees, contractors, and affiliates from claims arising out of:
              <Box component="ul">
                <Box component="li">Your uploaded content</Box>
                <Box component="li">Your Digital Twin</Box>
                <Box component="li">Your Authority Page</Box>
                <Box component="li">AI-generated Outputs you publish or distribute</Box>
                <Box component="li">Student disputes</Box>
                <Box component="li">Intellectual property claims</Box>
                <Box component="li">Violations of law</Box>
                <Box component="li">Misuse of AI systems</Box>
                <Box component="li">Fraudulent or deceptive conduct</Box>
              </Box>
            </Typography>

            {/* 16 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              16. Account Suspension &amp; Termination
            </Typography>
            <Typography>
              OceSha may suspend or terminate accounts for:
              <Box component="ul">
                <Box component="li">Violations of these Terms</Box>
                <Box component="li">Fraud or abuse</Box>
                <Box component="li">Regulatory risk</Box>
                <Box component="li">Security concerns</Box>
                <Box component="li">AI misuse</Box>
                <Box component="li">Non-payment</Box>
              </Box>
              Termination does not relieve users of prior obligations.
            </Typography>

            {/* 17 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              17. Arbitration &amp; Dispute Resolution
            </Typography>
            <Typography>
              All disputes arising out of these Terms or the Services shall be resolved through binding arbitration in California.<br /><br />
              You waive:
              <Box component="ul">
                <Box component="li">Jury trial rights</Box>
                <Box component="li">Participation in class actions</Box>
                <Box component="li">Class arbitration rights</Box>
              </Box>
            </Typography>

            {/* 18 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              18. Governing Law
            </Typography>
            <Typography>
              These Terms are governed by the laws of the State of California.<br />
              Venue and jurisdiction shall be Orange County, California.
            </Typography>

            {/* 19 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              19. Changes to Terms
            </Typography>
            <Typography>
              OceSha may update these Terms at any time.<br />
              Continued use of the Services after updates constitutes acceptance of revised Terms.
            </Typography>

            {/* 20 */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
              20. Contact
            </Typography>
            <Typography>
              OceSha, Inc. <br />
              <Link
                to=""
                onClick={(e) => {
                  window.location.href = `mailto:support@ocesha.com`;
                  e.preventDefault();
                }}
                style={{ color: "#0168B5" }}
              >
                support@ocesha.com
              </Link> <br />
              <Link
                to=""
                onClick={(e) => {
                  window.location.href = `https://ocesha.ai`;
                  e.preventDefault();
                }}
                style={{ color: "#0168B5" }}
              >
                https://ocesha.ai
              </Link>
            </Typography>

            <Link
              to="/signin"
              style={{
                display: "flex",
                marginTop: 40,
                textDecoration: "none",
                color: "white",
              }}
            >
              <SvgIcon sx={{ mr: 1 }}>
                <KeyboardBackspace />
              </SvgIcon>
              Back to log in
            </Link>
          </Box>
      </Container>

      
    </>
  );
};

export default TermsPage;